export const woonenergieImageTokens = {
  imageSplitviewBorderRadii: '0',
};
